import { createContext } from "react";
export const ShortcutContext = createContext([
    [],
    () => []
]);
//# sourceMappingURL=index.js.map